var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFridged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fridge"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.8406 32.1556H10.082C8.35777 32.1556 6.95456 30.6942 6.95456 28.8978V3.25843C6.95456 1.46144 8.35777 0 10.082 0H24.84C26.5653 0 27.968 1.46144 27.968 3.25843V28.8978C27.968 30.6942 26.5653 32.1556 24.8406 32.1556ZM10.082 2.05728C9.44643 2.05728 8.92965 2.59626 8.92965 3.25787V28.8972C8.92965 29.5594 9.44696 30.0984 10.082 30.0984H24.84C25.4756 30.0984 25.9924 29.5594 25.9924 28.8978V3.25843C25.9924 2.59626 25.475 2.05784 24.84 2.05784L10.082 2.05728Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.0087 9.86106H10.9144C10.3687 9.86106 9.92682 9.40067 9.92682 8.83214C9.92682 8.26362 10.3692 7.80322 10.9144 7.80322H24.0087C24.5544 7.80322 24.9968 8.26362 24.9968 8.83214C24.9968 9.40067 24.5538 9.86106 24.0087 9.86106Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M24.0087 14.8564H10.9144C10.3687 14.8564 9.92682 14.396 9.92682 13.8275C9.92682 13.259 10.3692 12.7986 10.9144 12.7986H24.0087C24.5544 12.7986 24.9968 13.259 24.9968 13.8275C24.9968 14.396 24.5538 14.8564 24.0087 14.8564Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M24.0087 19.8728H10.9144C10.3687 19.8728 9.92682 19.4124 9.92682 18.8439C9.92682 18.2753 10.3692 17.8149 10.9144 17.8149H24.0087C24.5544 17.8149 24.9968 18.2753 24.9968 18.8439C24.9968 19.4124 24.5538 19.8728 24.0087 19.8728Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M24.0087 24.8891H10.9144C10.3687 24.8891 9.92682 24.4287 9.92682 23.8602C9.92682 23.2917 10.3692 22.8313 10.9144 22.8313H24.0087C24.5544 22.8313 24.9968 23.2917 24.9968 23.8602C24.9968 24.4287 24.5538 24.8891 24.0087 24.8891Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M12.0937 34H9.30473C9.18851 34 9.09439 33.5012 9.09439 32.8853C9.09439 32.2693 9.18862 31.7705 9.30473 31.7705H12.0937C12.2099 31.7705 12.3042 32.2693 12.3042 32.8853C12.3042 33.5012 12.2098 34 12.0937 34Z",
    fill: "#395723"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M24.9329 34H22.1439C22.0277 34 21.9336 33.5012 21.9336 32.8853C21.9336 32.2693 22.0278 31.7705 22.1439 31.7705H24.9329C25.0491 31.7705 25.1434 32.2693 25.1434 32.8853C25.1434 33.5012 25.049 34 24.9329 34Z",
    fill: "#395723"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFridged);
export default __webpack_public_path__ + "static/media/fridged.4e416243473770380a5ed2c785d449a2.svg";
export { ForwardRef as ReactComponent };